import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';

import { type QueryStateSchema, backwardsCompatabilityFactory, queryParam, queryStateParser } from './queryStateParser';

const QS_KEY = 'paneFormRequestTemplateSlug';
const QS_TYPE: QueryStateSchema['type'] = 'formRequestTemplate';

export const useOpenFormRequestTemplatePane = (): ((args: {
  formRequestTemplateSlug: string;
  formRequestTemplateId?: string;
}) => void) => {
  const [formRequestTemplateSlugDeprecated, setFormRequestTemplateSlug] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (formRequestTemplateSlugDeprecated) {
      setFormRequestTemplateSlug(null);
      setState(backwardsCompatabilityFactory({ id: formRequestTemplateSlugDeprecated, type: QS_TYPE }));
    }
  }, [formRequestTemplateSlugDeprecated]);

  return ({ formRequestTemplateSlug, formRequestTemplateId }) => {
    setState((prevState) => [
      ...(prevState || []),
      {
        formRequestTemplateId,
        id: formRequestTemplateSlug,
        key: nanoid(),
        type: QS_TYPE,
      },
    ]);
  };
};
